import { num } from '../../scene/component-types.js';
import type { SettingsSection } from '../settings-types.js';

/**
 * `settings.input` (prism_core::InputSettings). Nothing is built into the
 * engine: every action / axis a script reads must be defined here.
 */
const input: SettingsSection = {
  key: 'input',
  label: 'Input',
  icon: 'command',
  order: 30,
  hint: 'Actions and axes for keyboard, mouse and gamepads',
  fields: [
    {
      key: 'actions',
      label: 'Actions',
      type: { kind: 'inputBindings' },
      hint: 'action_down / action_pressed / action_released(name): down while any code is down',
    },
    {
      key: 'axes',
      label: 'Axes',
      type: { kind: 'inputBindings', axes: true },
      hint: 'axis(name): −1..1; keys give ±1, gamepad sticks / triggers their analog value',
    },
    {
      key: 'gamepad',
      label: 'Gamepad',
      type: {
        kind: 'object',
        fields: [
          { key: 'stickDeadzone', label: 'Stick dead zone', type: num(0.01, { min: 0, max: 1 }), read: () => 0.15 },
          { key: 'triggerDeadzone', label: 'Trigger dead zone', type: num(0.01, { min: 0, max: 1 }), read: () => 0.05 },
          {
            key: 'pressThreshold',
            label: 'Press threshold',
            type: num(0.05, { min: 0, max: 1 }),
            read: () => 0.5,
            hint: 'value at which a trigger / half axis (LeftX+) counts as pressed for actions',
          },
        ],
      },
    },
  ],
};

export default input;
